'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var zoomIn = {
  from: {
    opacity: 0,
    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
  },
  '50%': {
    opacity: 1
  }
};
exports.default = zoomIn;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/zoom-in.js
// module id = 270
// module chunks = 54990529738226 257444579329143